export const SET_PAGE = 'SET_PAGE';
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE';
export const RESET_PAGINATION = 'RESET_PAGINATION';

export const SET_TOTAL = 'SET_TOTAL';

export const SET_SORT_BY = 'SET_SORT_BY';

export const SET_FILTERS = 'SET_FILTERS';
export const RESET_FILTERS = 'RESET_FILTERS';